import Reveal from "../Reveal";
import { LogoMark } from "../Logo";

const STEPS = [
  { n: "01", title: "Discovery", desc: "We interrogate your market, audience and data until the real growth lever reveals itself." },
  { n: "02", title: "Architecture", desc: "Strategy, brand systems and technical blueprints designed as one uncompromising machine." },
  { n: "03", title: "Execution", desc: "Design, code and media shipped in kinetic sprints with obsessive craft at every pixel." },
  { n: "04", title: "Dominance", desc: "Relentless optimization loops turn early wins into market-leading momentum." },
];

const TESTIMONIALS = [
  { quote: "Zork rebuilt our funnel and brand in eight weeks. Conversion tripled. They operate like a special-forces unit, not an agency.", name: "Marcus Zork", role: "Founder & Creative Director", avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?crop=entropy&cs=srgb&fm=jpg&w=300&q=85" },
  { quote: "The most precise team we have ever worked with. Every sprint shipped, every metric moved. Our board now quotes their reports verbatim.", name: "Elena Rostova", role: "Head of Digital Strategy", avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?crop=entropy&cs=srgb&fm=jpg&w=300&q=85" },
];

export default function Process() {
  return (
    <section id="process" className="py-28 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-volt mb-4">03 / Methodology</p>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-4xl lg:text-5xl leading-tight max-w-2xl">
            The path to <span className="text-volt">dominance</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className="bg-obsidian p-8 lg:p-10 group hover:bg-panel transition-colors duration-500" >
              <span className="font-display font-extrabold text-4xl text-stroke group-hover:text-volt group-hover:[-webkit-text-stroke:0] transition-all duration-500">{s.n}</span>
              <h3 className="mt-10 font-display font-semibold text-xl tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            </Reveal>
          ))}
        </div>

        <div className="mt-24 grid grid-cols-1 lg:grid-cols-2 gap-4">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12} className="border border-white/5 bg-panel/60 p-8 lg:p-12 relative overflow-hidden">
              <div className="absolute top-0 right-0 opacity-[0.06] pointer-events-none -translate-y-6 translate-x-6">
                <LogoMark size={120} />
              </div>
              <p className="text-lg sm:text-xl leading-relaxed text-slate-200 font-light relative">“{t.quote}”</p>
              <div className="mt-8 flex items-center gap-4">
                <img src={t.avatar} alt={t.name} loading="lazy" className="w-12 h-12 object-cover grayscale border border-white/10" />
                <div>
                  <p className="font-display font-semibold tracking-tight">{t.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">{t.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
